import HTTP from '@/utils/http-common';
import { BAD_LOAD, UPDATE_LOCAL_USER, UPDATE_USER, UPDATE_USER_PENDING, UPDATE_USER_SETTINGS } from './constants';
import { ROLES_ACCESS } from '../../portals/utils';
import { hasRoleTool } from '../../utils/role-accees';

const state = {
  user: {},
  pending: false
};

const checkUserRole = (user, role) => user?.roles.map((role) => role.name).includes(role); //TODO: very bad, should not compare with dynamic name
const checkUserRoles = (user, roles) => roles.some((role) => checkUserRole(user, role));

const getters = {
  loggedInUser: (state) => (state.user && state.user._id ? state.user : null),
  needToSetupUser: ({ user }) => {
    return user?.source === 'signup' && !user.distributorId;
  },
  isManagerOrExecutive: (state) =>
    hasRoleTool(state.user?.roles, [
      ROLES_ACCESS.TOOLS.IS_SUPER_ADMIN,
      ROLES_ACCESS.TOOLS.USER_AS_EXECUTIVE,
      ROLES_ACCESS.TOOLS.USER_AS_ADMIN,
      ROLES_ACCESS.TOOLS.USER_AS_MANAGER
    ]) ||
    state.user?.roles
      ?.map((e) => (e.settings && e.settings.general) || [])
      .reduce((a, b) => [...a, ...b], [])
      .includes(ROLES_ACCESS.TOOLS.USER_AS_SALE_ADMIN),
  isManager: (state) =>
    hasRoleTool(state.user?.roles, [
      ROLES_ACCESS.TOOLS.IS_SUPER_ADMIN,
      ROLES_ACCESS.TOOLS.USER_AS_ADMIN,
      ROLES_ACCESS.TOOLS.USER_AS_MANAGER
    ]),
  isSuperAdmin: (state) => hasRoleTool(state.user?.roles, [ROLES_ACCESS.TOOLS.IS_SUPER_ADMIN]),
  isDistributorAdmin: (state) => hasRoleTool(state.user?.roles, [ROLES_ACCESS.TOOLS.USER_AS_DISTRIBUTOR_ADMIN]),
  isSupplierAdmin: (state) => hasRoleTool(state.user?.roles, ROLES_ACCESS.ADMIN_SUPPLIER),
  userPending: (state) => state.pending,
  showOrdersFilterSalesPerson: (state) =>
    hasRoleTool(state.user?.roles, [ROLES_ACCESS.TOOLS.USER_SHOW_ORDERS_FILTER_SALES_PERSON])
};

const actions = {
  async get_user({ commit }, userId) {
    let currentUser;
    try {
      currentUser = await HTTP.get(`/users/${userId}?checkStores=true&withPlans=true`, userId);
      const rolesNotifications = currentUser.data?.settings?.notifications?.rolesNotifications
        ? currentUser.data?.settings?.notifications?.rolesNotifications
        : { po: [], orderStatus: [] };
      commit('SET_USER', currentUser.data);
      commit('setRolesNotification', rolesNotifications);
      localStorage.setItem('env', JSON.stringify(currentUser.data.env));
    } catch (e) {
      console.log(e);
    }
    return currentUser;
  },
  async updateUser({ commit, state }, user) {
    try {
      commit(UPDATE_USER_PENDING, true);
      const res = await HTTP.put(`/users/${user._id}`, user);
      Object.assign(user, res.data.model);
      if (user._id === state.user._id) {
        commit(UPDATE_USER, res.data.model);
      }
    } catch (e) {
      commit(BAD_LOAD, e.data ? e.data.message : e.message || e, { root: true });
    } finally {
      commit(UPDATE_USER_PENDING, false);
    }
  },
  async updateUserSettings({ commit, state }, settings) {
    try {
      commit(UPDATE_USER_PENDING, true);
      const res = await HTTP.put(`/user/settings`, settings);
      commit(UPDATE_USER_SETTINGS, res.data);
    } catch (e) {
      commit(BAD_LOAD, e.data ? e.data.message : e.message || e, { root: true });
    } finally {
      commit(UPDATE_USER_PENDING, false);
    }
  },
  async updateLocalUser({ commit, state }, user) {
    commit(UPDATE_LOCAL_USER, user);
  }
};

const mutations = {
  SET_USER(state, user) {
    state.user = user;
    if (!user.settings) user.settings = {};
    if (!user.settings.notifications) user.settings.notifications = {};
  },
  UPDATE_USER_SETTINGS(state, settings) {
    Object.assign(state.user.settings, settings);
    state.user = JSON.parse(JSON.stringify(state.user));
  },
  [UPDATE_LOCAL_USER](state, user) {
    Object.assign(state.user, user);
    state.user = JSON.parse(JSON.stringify(state.user));
  },
  [UPDATE_USER_PENDING](state, val) {
    state.pending = val;
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
